import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-kiosk-confirm',
	templateUrl: './kiosk-confirm.component.html',
	styleUrls: ['./kiosk-confirm.component.scss'],
})
export class KioskConfirmComponent {
	@Input() remainingSeconds = 60;
	@Output() startOverEmitter = new EventEmitter();

	// biome-ignore lint/complexity/noUselessConstructor: <explanation>
	constructor() {}

	startOver() {
		this.startOverEmitter.emit();
	}
}
